import OpenReplay from "@openreplay/tracker";
import { env } from "@/env";
import { useEffect } from "react";

const tracker = new OpenReplay({
  projectKey: env.VITE_OPENREPLAY_PROJECT_KEY,
  ingestPoint: env.VITE_OPENREPLAY_INGEST_POINT,
  __DISABLE_SECURE_MODE: true,
  inlineCss: 3,
});

function OpenReplayProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    tracker.start({
      metadata: {
        domain: window.location.hostname,
      },
    });
  }, []);

  return <>{children}</>;
}

export default OpenReplayProvider;
